import React, { useEffect, useState } from 'react';
import * as API from '../helpers/api';
import config from '../config';
import Loading from 'react-loader-spinner';
import { useLang } from '../helpers/language';
import parse from 'html-react-parser';

import { Link } from 'react-router-dom';
import AboutBlock from '../components/about-block/AboutBlock';
import BrewPubSlider from '../components/brewpub-slider/BrewpubSlider';
import CupModal from '../components/cup-modal/CupModal';
import useScroll from '../assets/hooks/useScroll';
import '../assets/css/pages/brewpub.scss';
import { Dictionary } from '../assets/js/contexts';

const BrewPub = ({ dictionary }) => {
	const [cup, toggleCup] = useState(null);
	const [cups, setCups] = useState([]);
	const [cupPage, setCupPage] = useState([]);
	const [brewpub, setBrewpub] = useState([]);
	const scroll = useScroll();
	const { lang } = useLang();
	const [isBusy, setBusy] = useState(true);

	useEffect(() => {
		window.scrollTo(0, 0);
		(async () => {
			let rawCups = await API.get(config.api.cup, {}, {}, true);
			setCups(rawCups);

			let rawCupPage = await API.get(config.api.cupPage);
			setCupPage(rawCupPage[0]);

			let rawBrewpub = await API.get(config.api.brewpub);
			setBrewpub(rawBrewpub[0]);

			setBusy(false);
		})();
		window.scrollTo(0, 0);
	}, [isBusy]);

	if (!isBusy && brewpub)
		return (
			<Dictionary.Provider value={dictionary}>
				<div id='brewpub'>
					<div className='header'>
						<div
							className='container animate'
							data-expand={scroll > 20}
						></div>
						<div className='container'>
							<div className='row'>
								<div className='col-12 content'>
									<h1>
										{brewpub.title[lang]
											? brewpub?.title[lang]
											: ''}
									</h1>
									{parse(
										brewpub.desc[lang]
											? brewpub.desc[lang]
											: ''
									)}
								</div>
							</div>
						</div>
					</div>

					<div className='menu'>
						<div className='container'>
							<div className='row justify-content-center'>
								<div className='col-md-6'>
									<h2>
										{
											config.pages.brewpub.ourMenu.title[
												lang
											]
										}
									</h2>
									<p>
										{
											config.pages.brewpub.ourMenu.desc[
												lang
											]
										}
									</p>
									<div className='d-flex justify-content-center'>
										<a
											href='https://menu.dargett.com'
											blank='true'
										>
											<button
												className='round primary'
												aria-label='round primary'
											>
												{
													config.pages.brewpub.ourMenu
														.button[lang]
												}
											</button>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className='slider-container'>
						<div className='container'>
							<div className='row'>
								<div className='col-12'>
									<BrewPubSlider
										cups={cups}
										toggleCup={toggleCup}
										cupPage={cupPage}
										config={config}
									/>
								</div>
							</div>
						</div>
					</div>

					<AboutBlock
						title={config.aboutUsBlock.brewpub.title[lang]}
						subTitle={''}
						content={''}
						buttonText={config.aboutUsBlock.brewpub.button[lang]}
						as={'/beer'}
						href={'/beer'}
					/>
					{cup !== null && (
						<CupModal
							cups={cups}
							activeIndex={cup}
							cup={cup}
							toggleCup={toggleCup}
							config={config}
						/>
					)}
				</div>
			</Dictionary.Provider>
		);
	else return <Loading type='Oval' color='#FFBE03' className='dms-loader' />;
};

export default BrewPub;
